kv.controller('holidayListCtrl', function ($element, $attrs, $scope, $injector) {
	return new dictionaryListCtrl($element, $attrs, $scope, $injector, {
		primaryKey: "holiday_id",
		entity: "holiday",
		modal: {
			templateUrl: "holiday-edit",
			controller: "holidayEditCtrl"
		}
	});
});
